// extracted by mini-css-extract-plugin
export default {"root":"global-module__root__z0SBuPK"};